/* Hiperbola designer interactions
   Ported from the webdesigner reference (research/reference/hiperbola/script.js).
   Behaviors:
   1. Hamburger close-on-outside (escape, outside click, desktop resize)
   2. FAQ exclusive-open (.faq-element used as <details>)
   3. Karuzela auto-advance (.karuzela) - paused on hover/touch, disabled when the track fits
   4. Studio gallery carousel (.galeria-studio) - prev/next + auto-advance
   5. Metamorfoza before/after slider (.slider-metamorfozy)
   6. Comparison TreeWalker highlight (.komorka-porownania)
   7. Ebook popup (.popup-ebook) - shown when .gwarancja-satysfakcji scrolls into view
*/
(function () {
  "use strict";

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    initHamburgerClose();
    initFaq();
    initKaruzelaAutoAdvance();
    initGalleryStudio();
    initMetamorfozaSlider();
    initComparisonWalker();
    initEbookPopup();
  });

  /* 1. Hamburger - outside click / escape / desktop close */
  function initHamburgerClose() {
    var hamburger = document.querySelector(".hamburger");
    var navList = document.querySelector(".nav-list");
    if (!hamburger || !navList) return;

    function closeMenu() {
      if (!navList.classList.contains("active")) return;
      navList.classList.remove("active");
      hamburger.classList.remove("active");
      hamburger.setAttribute("aria-expanded", "false");
      document.body.classList.remove("menu-open");
      document.body.style.overflow = "";
    }

    document.addEventListener("click", function (event) {
      var inside = navList.contains(event.target) || hamburger.contains(event.target);
      if (!inside && navList.classList.contains("active")) {
        closeMenu();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && navList.classList.contains("active")) {
        closeMenu();
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 768) closeMenu();
    });
  }

  /* 2. FAQ - exclusive accordion (native <details> + close siblings) */
  function initFaq() {
    var faqElements = document.querySelectorAll(".faq-element");
    if (!faqElements.length) return;

    faqElements.forEach(function (element) {
      var button = element.querySelector(".faq-pytanie");
      if (!button) return;

      button.setAttribute("aria-expanded", element.open ? "true" : "false");

      button.addEventListener("click", function () {
        var willOpen = !element.open;

        faqElements.forEach(function (otherElement) {
          if (otherElement !== element && otherElement.open) {
            otherElement.open = false;
          }
          var otherButton = otherElement.querySelector(".faq-pytanie");
          if (otherButton) {
            otherButton.setAttribute("aria-expanded", otherElement.open ? "true" : "false");
          }
        });

        element.classList.toggle("active", willOpen);
        button.setAttribute("aria-expanded", String(willOpen));
      });
    });
  }

  /* 3. Karuzela (gallery) auto-advance - complements media-slider scrolling */
  function initKaruzelaAutoAdvance() {
    var karuzela = document.querySelector(".karuzela");
    if (!karuzela) return;

    var lista = karuzela.querySelector(".lista-zdjec");
    var okno = karuzela.querySelector(".karuzela-okno");
    var zdjecia = karuzela.querySelectorAll(".lista-zdjec img");
    if (!lista || !okno || zdjecia.length < 2) return;

    var timer = null;
    var resumeTimeout = null;

    function zwrocKrok() {
      var slide = lista.querySelector(":scope > *") || zdjecia[0];
      var style = window.getComputedStyle(lista);
      var odstep = parseFloat(style.columnGap || style.gap) || 0;
      return slide.getBoundingClientRect().width + odstep;
    }

    function miesciSie() {
      return lista.scrollWidth <= okno.clientWidth + 1;
    }

    function nastepny() {
      if (miesciSie()) return;
      var maks = lista.scrollWidth - okno.clientWidth;
      if (lista.scrollLeft >= maks - 1) {
        lista.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        lista.scrollBy({ left: zwrocKrok(), behavior: "smooth" });
      }
    }

    function zatrzymaj() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function uruchom() {
      zatrzymaj();
      if (miesciSie()) return;
      timer = window.setInterval(nastepny, 2500);
    }

    karuzela.addEventListener("mouseenter", zatrzymaj);
    karuzela.addEventListener("mouseleave", uruchom);
    karuzela.addEventListener("focusin", zatrzymaj);
    karuzela.addEventListener("focusout", uruchom);
    karuzela.addEventListener(
      "touchstart",
      function () {
        zatrzymaj();
        if (resumeTimeout) window.clearTimeout(resumeTimeout);
        resumeTimeout = window.setTimeout(uruchom, 3000);
      },
      { passive: true },
    );

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        zatrzymaj();
      } else {
        uruchom();
      }
    });

    window.addEventListener("resize", function () {
      window.requestAnimationFrame(function () {
        if (miesciSie()) {
          zatrzymaj();
        } else {
          uruchom();
        }
      });
    });

    var prev = karuzela.querySelector(".prev");
    var next = karuzela.querySelector(".next");
    if (prev) prev.addEventListener("click", uruchom);
    if (next) next.addEventListener("click", uruchom);

    uruchom();
  }

  /* 4. Studio gallery carousel - prev/next + auto-advance + pause on hover/touch */
  function initGalleryStudio() {
    var galeria = document.querySelector(".galeria-studio");
    if (!galeria) return;

    var okno = galeria.querySelector(".galeria-studio-okno");
    var lista = galeria.querySelector(".galeria-studio-lista");
    var zdjecia = galeria.querySelectorAll(".galeria-studio-lista img");
    var next = galeria.querySelector(".studio-next");
    var prev = galeria.querySelector(".studio-prev");
    if (!okno || !lista || zdjecia.length === 0 || !next || !prev) return;

    var indeks = 0;
    var automat = null;

    function odstep() {
      var style = window.getComputedStyle(lista);
      var wartosc = parseFloat(style.columnGap || style.gap);
      return Number.isFinite(wartosc) ? wartosc : 0;
    }

    function liczbaWidocznych() {
      if (window.innerWidth <= 700) return 1;
      if (window.innerWidth <= 1000) return 2;
      return 3;
    }

    function maksymalnyIndeks() {
      return Math.max(0, zdjecia.length - liczbaWidocznych());
    }

    function krok() {
      return zdjecia[0].getBoundingClientRect().width + odstep();
    }

    function miesciSie() {
      return zdjecia.length <= liczbaWidocznych();
    }

    function przesun() {
      indeks = Math.min(Math.max(indeks, 0), maksymalnyIndeks());
      lista.style.transform = "translateX(-" + indeks * krok() + "px)";
    }

    function nastepne() {
      indeks = indeks >= maksymalnyIndeks() ? 0 : indeks + 1;
      przesun();
    }

    function poprzednie() {
      indeks = indeks <= 0 ? maksymalnyIndeks() : indeks - 1;
      przesun();
    }

    function zatrzymaj() {
      if (automat !== null) {
        window.clearInterval(automat);
        automat = null;
      }
    }

    function uruchom() {
      zatrzymaj();
      if (miesciSie()) return;
      automat = window.setInterval(nastepne, 3000);
    }

    next.addEventListener("click", function () {
      nastepne();
      uruchom();
    });

    prev.addEventListener("click", function () {
      poprzednie();
      uruchom();
    });

    galeria.addEventListener("mouseenter", zatrzymaj);
    galeria.addEventListener("mouseleave", uruchom);
    galeria.addEventListener("focusin", zatrzymaj);
    galeria.addEventListener("focusout", uruchom);
    galeria.addEventListener(
      "touchstart",
      function () {
        zatrzymaj();
        window.setTimeout(uruchom, 3000);
      },
      { passive: true },
    );

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        zatrzymaj();
      } else {
        uruchom();
      }
    });

    window.addEventListener("resize", function () {
      window.requestAnimationFrame(przesun);
    });

    zdjecia.forEach(function (zdjecie) {
      zdjecie.addEventListener("load", przesun);
    });

    przesun();
    uruchom();
  }

  /* 5. Metamorfoza before/after slider */
  function initMetamorfozaSlider() {
    var lista = document.querySelector(".slider-metamorfozy-lista");
    var slajdy = document.querySelectorAll(".metamorfoza-slajd");
    var lewo = document.querySelector(".metamorfozy-lewo");
    var prawo = document.querySelector(".metamorfozy-prawo");
    if (!lista || slajdy.length === 0 || !lewo || !prawo) return;

    var indeks = 0;

    function zmien() {
      lista.style.transform = "translateX(-" + indeks * 100 + "%)";
    }

    prawo.addEventListener("click", function () {
      indeks = (indeks + 1) % slajdy.length;
      zmien();
    });

    lewo.addEventListener("click", function () {
      indeks = (indeks - 1 + slajdy.length) % slajdy.length;
      zmien();
    });

    zmien();
  }

  /* 6. Comparison TreeWalker highlight (non-breaking spaces after 1-letter words) */
  function initComparisonWalker() {
    document.querySelectorAll(".komorka-porownania").forEach(function (komorka) {
      var walker = document.createTreeWalker(komorka, NodeFilter.SHOW_TEXT);
      var teksty = [];

      while (walker.nextNode()) {
        teksty.push(walker.currentNode);
      }

      teksty.forEach(function (tekst) {
        tekst.nodeValue = tekst.nodeValue.replace(/(^|\s)([aiouwz])\s+/gi, "$1$2\u00A0");
      });
    });
  }

  /* 7. Ebook popup - show once when guarantee section scrolls into view */
  function initEbookPopup() {
    var popup = document.querySelector(".popup-ebook");
    var zamknij = document.querySelector(".popup-ebook-zamknij");
    var gwarancja = document.querySelector(".gwarancja-satysfakcji");
    if (!popup || !zamknij || !gwarancja) return;

    if (window.Shopify && Shopify.designMode) return;

    var pokazany = false;

    function pokaz() {
      if (pokazany) return;
      pokazany = true;
      popup.style.display = "flex";
      popup.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }

    function ukryj() {
      popup.style.display = "none";
      popup.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    var obserwator = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !pokazany) {
            pokaz();
          }
        });
      },
      { threshold: 0.4 },
    );

    obserwator.observe(gwarancja);

    zamknij.addEventListener("click", ukryj);

    popup.addEventListener("click", function (event) {
      if (event.target === popup) ukryj();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && popup.style.display === "flex") ukryj();
    });
  }
})();
